export const getCurrentErrors = (questions, responseState) => {
    return questions
        .filter((q) => responseState[q.questionId]?.isValid === false && !responseState[q.questionId]?.hideInForm)
        .map((q) => ({
            label: q.label.value,
            invalidMessage: q.invalidMessage?.value,
            questionId: q.questionId
        }));
};
